import { ReactNode } from 'react'
import { Box } from '@mui/material'
import Navbar from '../components/navbar'
// import Sidebar from "../components/sidebar";

interface LayoutProps {
  children: ReactNode
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        color: 'white',
        height: '100vh',
        overflowY: 'auto',
      }}
    >
      <Navbar />

      {children}
    </Box>
  )
}

export default Layout
